// Tableau 3 — Communication et sensibilisation : programme, thème, participants hommes / femmes ; total calculé.
import { PROGRAMMES_COMMUNICATION, validerSeanceCommunication, totalSeance } from '../../../../shared/business-logic/index.ts';
import type { SeanceCommunication } from '../../../../shared/business-logic/index.ts';
import { useModules } from '../../hooks/useModules.ts';
import { EnteteModule, NombreInput, PasDePeriode, Message } from '../../components/ui.tsx';
import type { Periode } from '../Accueil.tsx';

export default function Communication({ periode }: { periode: Periode | null }) {
  const m = useModules(periode);
  if (!periode) return <PasDePeriode />;
  if (!m.pret) return <p>Chargement…</p>;
  const calc = m.calc;
  if (!calc) return <Message niveau="warn">{m.erreur ?? 'Données indisponibles.'}</Message>;
  const lignes = m.saisies('COMMUNICATION');
  const t = calc.communication;

  async function ajouter() { await m.ecrire('COMMUNICATION', `c-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`, { programme: '', theme: '', hommes: null, femmes: null } as SeanceCommunication); }
  async function maj(cle: string, brut: SeanceCommunication, champ: keyof SeanceCommunication, v: any) { await m.ecrire('COMMUNICATION', cle, { ...brut, [champ]: v }); }

  return (
    <div>
      <EnteteModule titre="Tableau 3 — Communication et sensibilisation" periode={periode} statut={periode.statut} lectureSeule={m.lectureSeule} aide="Une ligne par séance. Le total se calcule seul." />
      <div className="defil">
        <table className="saisie">
          <thead><tr><th>#</th><th>Programme</th><th>Thème de la séance</th><th>Hommes</th><th>Femmes</th><th>Total</th><th /></tr></thead>
          <tbody>
            {lignes.map((l, i) => {
              const d = l.donnees as SeanceCommunication;
              const v = validerSeanceCommunication(d);
              return (
                <tr key={l.cle}>
                  <td>{i + 1}</td>
                  <td><select aria-label="Programme" value={d.programme} disabled={m.lectureSeule} className={!v.ok ? 'bad' : ''} onChange={(e) => maj(l.cle, d, 'programme', e.target.value)}>
                    <option value="">Programme…</option>
                    {[...PROGRAMMES_COMMUNICATION, ...(d.programme && !(PROGRAMMES_COMMUNICATION as readonly string[]).includes(d.programme) ? [d.programme] : [])].map((p) => <option key={p}>{p}</option>)}
                  </select></td>
                  <td><input aria-label="Thème" value={d.theme} maxLength={200} disabled={m.lectureSeule} className={!v.ok ? 'bad' : ''} placeholder="Thème de la séance" onChange={(e) => maj(l.cle, d, 'theme', e.target.value)} />
                    {(v.erreurs[0] || v.alertes[0]) && <small className={v.erreurs[0] ? 'bad' : 'warn'}>{v.erreurs[0] ?? v.alertes[0]}</small>}</td>
                  <td><NombreInput label="Participants hommes" valeur={d.hommes} disabled={m.lectureSeule} onChange={(x) => maj(l.cle, d, 'hommes', x)} /></td>
                  <td><NombreInput label="Participantes femmes" valeur={d.femmes} disabled={m.lectureSeule} onChange={(x) => maj(l.cle, d, 'femmes', x)} /></td>
                  <td className="calcule">{totalSeance(d)}</td>
                  <td>{!m.lectureSeule && <button className="x" title="Supprimer la ligne" onClick={() => m.supprimer('COMMUNICATION', l.cle)}>✕</button>}</td>
                </tr>
              );
            })}
            {lignes.length === 0 && <tr><td colSpan={7} className="vide">Aucune séance saisie ce mois.</td></tr>}
          </tbody>
          <tfoot><tr><td colSpan={3}>Total</td><td>{t.hommes}</td><td>{t.femmes}</td><td>{t.total}</td><td /></tr></tfoot>
        </table>
      </div>
      {!m.lectureSeule && <p><button onClick={ajouter}>+ Ajouter une séance</button></p>}
    </div>
  );
}
